<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">Permissions — {{ data.viewLabel }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>
  <p class="dialog-hint">A permission in use by a role or user cannot be detached.</p>

  <table class="table">
    <thead>
      <tr>
        <th>Permission</th>
        <th>Label</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      @for(pair of pairs; track pair.svpId){
      <tr>
        <td>{{ pair.permissionName }}</td>
        <td>{{ pair.permLabel }}</td>
        <td><button type="button" class="ac-danger-btn" (click)="detach(pair)">Detach</button></td>
      </tr>
      } @empty {
      <tr><td colspan="3">No permissions attached.</td></tr>
      }
    </tbody>
  </table>

  <div class="add-row">
    <div class="field">
      <span class="field-label">Permission</span>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" [formControl]="permissionId">
          @for(p of permissions; track p.permissionId){ <mat-option [value]="p.permissionId">{{ p.permLabel }}</mat-option> }
        </mat-select>
      </mat-form-field>
    </div>
    <button type="button" class="ac-primary-btn" (click)="attach()">Attach</button>
  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
